<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="tableColumn" :data="tagMappingData" style="width: 100%;">
            <template slot-scope="{row,index}" slot="action">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="delMappingTagModalVisible = true">{{ $t('alarms.common.delete') }}</Button>
                </span>
            </template>
        </Table>
        <br/>
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
        <!-- 删除映射标签模式框 -->
        <Modal v-model="delMappingTagModalVisible"  width="360" :mask-closable="false">
            <p slot="header" style="color:#ff6600;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{deleteName}} ?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="loading" @click="removeTag()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    let tableTagMapping = {};
    export default {
        name: 'TableTagMapping',
        data() {
            return {
                current: 1,
                dataTotal: 0,
                pageSize: 10,
                standardTagId: '',
                deleteName:'',
                loading:false,
                isDisable:false,
                delMappingTagModalVisible: false,
                tableColumn: [
                {
                    title: this.$t('tag.mappingTag'),
                    key: 'resourceTag'
                },
                {
                    title: this.$t('common.operation'),
                    slot: 'action',
                    width: 150
                }],
                tagMappingData: []
            }
        },
        beforeCreate: function () {
            tableTagMapping = this
        },
        mounted: function () {
            tableTagMapping.getData();
        },
        methods: {
            // 显示数据
            showAll: function () {
                tableTagMapping.getData();
            },
            // 根据标签查询资源
            getData: function () {
                eventBus.$on('standardTagId', function (val) {
                    tableTagMapping.val = val;
                })
                tableTagMapping.$api.tag.queryMappingTagByTagKeyId({
                    "pageNum": this.current,
                    "pageSize": this.pageSize,
                    "standardTagId": tableTagMapping.val
                })
                .then(res => {
                    this.tagMappingData =res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                })
            },
            changePage: function (current) {
                this.current = current;
                tableTagMapping.getData();
            },
            changeSize: function (pageSize) {
                this.pageSize = pageSize;
                tableTagMapping.getData();
            },
            // 销毁
            beforeDestroy: function () {
                eventBus.$off('standardTagId');
            },
            // 删除
            /**************************************************************/
            doDelete: function (index) {
                this.lineIndex = index;
                this.deleteName = this.tagMappingData[index].resourceTag;
            },
            removeTag: function () {
                this.isDisable = true;  //开始可以点击
                var lineIndex = this.lineIndex;
                //删除
                this.$api.tag.delMappingTagById("id", this.tagMappingData[lineIndex].id)
                .then(res => {
                    this.loading = true;
                    setTimeout(() => {
                        tableTagMapping.getData();
                        this.isDisable = false;
                        this.loading = false;
                        this.delMappingTagModalVisible = false;
                        this.$Message.success(this.$t('common.deleteSuccess'));
                    }, 1000);
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/TableTagMapping.vue